exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".direction-picker_button-row_1DF8U {\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"button-row": "direction-picker_button-row_1DF8U",
	"buttonRow": "direction-picker_button-row_1DF8U"
};